<template>
  <div class="d-print-none" v-if="printIsActive">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-space-between align-center">
            <div>
              <p v-show="amountOfPrintItems > 0" class="mb-0">
                Ausgewählt:
                {{ amountOfPrintItems }}
              </p>
            </div>
            <v-btn
              :disabled="amountOfPrintItems === 0"
              dark
              @click.stop="$router.push('/drucken/uebersicht')"
            >
              Zur Druckübersicht
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PrintSelectorMultiple",
  computed: {
    ...mapGetters(["printIsActive", "amountOfPrintItems"]),
  },
  methods: {
    print() {
      window.print();
    }
  }
};
</script>

<style></style>
